import { EB, EB_DOMAIN } from '@chegg-wt/core/constants/site'
import { SiteEnv } from '@chegg-wt/core/types/site'

export default {
  siteInitials: EB,
  domain: EB_DOMAIN,
} as SiteEnv
